import React from 'react';
import ReactDOM from 'react-dom/client';
import 'css/index.css';
import 'css/responsive.css';
import App from 'components/App';
import * as serviceWorker from 'serviceWorker';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();